import { useApiClient } from '@@common';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { IntegrationEventAndPayloadModel, IntegrationEventsClient } from '../../../api/api';

export default function useApiIntegrationEvents(contextId: string): UseQueryResult<IntegrationEventAndPayloadModel[], Error> {
	const client = useApiClient(IntegrationEventsClient);
	
	// Add debugging and proper error handling
	const metadata = useQuery({
		queryKey: ['integrationEvents', contextId],
		queryFn: async () => {
			console.log('useApiIntegrationEvents - Making API call with contextId:', contextId);
			try {
				const result = await client.search(contextId, undefined, undefined);
				console.log('useApiIntegrationEvents - API response:', result);
				return result;
			} catch (error) {
				console.error('useApiIntegrationEvents - API error:', error);
				throw error;
			}
		},
		enabled: !!contextId, // Only run if contextId exists
		staleTime: 5 * 60 * 1000, // 5 minutes
		retry: 3,
	});
	
	console.log('useApiIntegrationEvents - Query state:', {
		data: metadata.data,
		isLoading: metadata.isLoading,
		isError: metadata.isError,
		error: metadata.error,
		contextId
	});
	
	return metadata;
}
